import { render, staticRenderFns } from "./LfCourse.vue?vue&type=template&id=62c28751&scoped=true&"
import script from "./LfCourse.vue?vue&type=script&lang=js&"
export * from "./LfCourse.vue?vue&type=script&lang=js&"
import style0 from "./LfCourse.vue?vue&type=style&index=0&id=62c28751&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c28751",
  null
  
)

export default component.exports